// filepath: c:\Users\gelis\Documents\GitHub\PisikolojiWeb\frontend\src\features\blog\blogService.js
import axios from 'axios';


const API_URL = process.env.REACT_APP_API_URL + '/api/blogs/';

// Tüm yazıları getir
const getPosts = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};

// YENİ: Slug'a göre tek bir yazı getir
const getPostBySlug = async (slug) => {
  const response = await axios.get(API_URL + slug);
  return response.data;
};

// Yeni bir yazı oluştur
const createPost = async (postData, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await axios.post(API_URL, postData, config);
  return response.data;
};

// Bir yazıyı güncelle
const updatePost = async (postId, postData, token) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.put(API_URL + postId, postData, config);
    return response.data;
  };

// Bir yazıyı sil
const deletePost = async (postId, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  // Backend'in { id: postId } döndürdüğünü varsayıyoruz
  const response = await axios.delete(API_URL + postId, config);
  return response.data;
};

const blogService = {
  getPosts,
  getPostBySlug, // Yeni fonksiyonu export et
  createPost,
  updatePost,
  deletePost,
};

export default blogService;